/**
 * /platform and /partner — the two consoles that are not a firm.
 * @file src/web/shared/layout.platform.tsx
 */
import { PartnerLayoutRoute, PlatformLayoutRoute } from './ConsoleLayoutRoute';
import type { LayoutEntry } from './layouts';

export const entries: LayoutEntry[] = [
  { match: (p) => p === '/platform' || p.startsWith('/platform/'), Layout: PlatformLayoutRoute, order: 90 },
  { match: (p) => p === '/partner' || p.startsWith('/partner/'), Layout: PartnerLayoutRoute, order: 91 },
];
